import IBalanceData from "@/interfaces/IBalanceData";
import { atom } from "recoil";


const LoyaltyBalanceDataAtom = atom<null | IBalanceData>({
    key: 'loyaltyBalanceDataAtomKey',
    default: null
})

export default LoyaltyBalanceDataAtom;